export const INVALID_FORMAT = 'INVALID_FORMAT';

export const INVALID_TOKEN = 'INVALID_TOKEN';

export const REPOSITORY_ALREADY_EXISTS = 'REPOSITORY_ALREADY_EXISTS';
